
import { DAOExpanderRegistryABI } from "../../abis/DAOExpanderRegistry.abi";
import { Web3ContractProvider, Web3ProviderExtras } from "../web3.provider";

import {
  DAOExpanderRegistryContractEventType,
  DAOExpanderRegistryContractFunctions,
  // @ts-ignore
} from "./sw-contract-functions";

const Web3DAOExpanderRegistryProvider = async (
  addressOrName: string,
  extras?: Partial<Web3ProviderExtras<DAOExpanderRegistryContractEventType>>
) => {
  return Web3ContractProvider<DAOExpanderRegistryContractEventType, DAOExpanderRegistryContractFunctions>(
    addressOrName,
    DAOExpanderRegistryABI,
    extras as Web3ProviderExtras<DAOExpanderRegistryContractEventType>
  );
};

export { Web3DAOExpanderRegistryProvider, DAOExpanderRegistryContractEventType, DAOExpanderRegistryContractFunctions };
